(function() {
	var menu = document.querySelector('.menu');
	if (menu) {
		document.querySelector('.menu__toggle').addEventListener('click', function(e) {
			e.preventDefault();
			menu.classList.toggle('menu--active');
			this.classList.toggle('is-active');
		});
	}

	menuItems = document.querySelectorAll('.header__menu');
	if (menuItems.length) {
		document.querySelector('.header__toggle').addEventListener('click', function(e) {
			e.preventDefault();
			for (var i = 0; i < menuItems.length; i++) {
				menuItems[i].classList.toggle('header__menu--active');
			}
			this.classList.toggle('is-active');
		});
	}

	var codeboxes = document.querySelectorAll('input.codebox');
	var onCodeChange = function(e) {
		
		// if back arrow or backspace is pressed
		var goBack = (e.keyCode === 8 || e.keyCode === 37);
		
		// if forward arrow is pressed
		var goForward = (e.keyCode === 39);
		 
		var val = this.value + "";
		
		var nextBox = this.nextSibling;
		if (nextBox) {
			if (goForward || val.length >= 1) {
				if (val.length > 1) {
					this.value = val.substring(0,1);
				}
				nextBox.focus();
				return;
			}
		}
		else {
			if (val.length >= 1) {
				this.value = val.substring(0,1);
				return
			}
		}
		var prevBox = this.previousSibling;
		if (prevBox && goBack) {
			prevBox.focus()
		}
		//nextBox.focus();
	};
	for (var i=0; i<codeboxes.length; i++) {
		codeboxes[i].addEventListener('keyup', onCodeChange);
	}

	// Toplist filter listener
	window.addEventListener('DOMContentLoaded', function() {
		var filterForm = document.getElementById('toplist-filter');

		if (!filterForm) {
			return;
		}

		var submitFilters = function() {
			if (this.name === 'region') {
				var countyFilter = document.getElementById('select-municipality');
				if (countyFilter) {
					countyFilter.selectedIndex = 0;
				}
			}
			filterForm.submit();
		};

		var fields = document.querySelectorAll('#toplist-filter select, #toplist-filter input[type="radio"]');
		for (var i=0; i<fields.length; i++) {
			fields[i].addEventListener('change', submitFilters);
		}
	});

})();

